var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-icon',[_c('i',{class:_vm.classObj,on:{"click":function($event){return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }